import { render } from "./EditBanner.vue?vue&type=template&id=39fd1a05&scoped=true"
import script from "./EditBanner.vue?vue&type=script&lang=js"
export * from "./EditBanner.vue?vue&type=script&lang=js"

import "./EditBanner.vue?vue&type=style&index=0&id=39fd1a05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39fd1a05"]])

export default __exports__